module.exports = __webpack_public_path__ + "static/media/icon_chip.09c898b0.svg";